export enum Variant {
  Tenant = 'tenant',
  Vad = 'vad',
}

export enum Scope {
  Accounting = 'accounting',
  Am = 'am',
  Bp = 'bp',
  Invoicing = 'invoicing',
  Reporting = 'reporting',
  System = 'system',
  Ui = 'ui',
  UiLib = 'ui-lib',
  User = 'user',
}
